import colors from './colors'
import * as sizes from './sizes'
import * as misc from './misc'
export default {
  colors,
  ...sizes,
  ...misc,
}
